<script>
import ContentBlockView from '@shared/mixins/ContentBlockView';

export default {
  mixins: [ContentBlockView],
  computed: {
    formattedText() {
      return this.getFormattedText(this.data.text);
    },
  },
};
</script>

<template>
  <component
    :is="`h${data.level}`"
    class="custom-title"
    :class="`has-text-weight-bold is-size-${data.level + 1}`"
  >
    {{ formattedText }}
  </component>
</template>
